import { render, staticRenderFns } from "./SelectCourier.vue?vue&type=template&id=21f4627e&"
import script from "./SelectCourier.vue?vue&type=script&lang=js&"
export * from "./SelectCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports